import {Injectable} from '@angular/core';
import { FormBuilder, FormGroup, Validators} from '@angular/forms'
import {
  NUMERIC_POSITIVE_FLOAT_PATTERN,
  NUMERIC_POSITIVE_PATTERN,
  NUMERIC_POSITIVE_PATTERN_WITH_DOT,
  NUMERIC_POSITIVE_PATTERN_WITH_DOT_0_TO_100
} from '../../shared';

@Injectable({
  providedIn: 'root'
})
export class GetFormsContractService {


  constructor(private fb: FormBuilder) {

  }
  // // promise
  // isUniquePromiseContract(myduplicate: DuplicateService): AsyncValidatorFn {
  //   return (control: AbstractControl): Promise<ValidationErrors | null> | Observable<ValidationErrors | null> => {
  //     if (control.disabled) {   return of(null);    }
  //     clearTimeout(this.contractTimeout);
  //     return new Promise((resolve, reject) => {
  //       this.contractTimeout = setTimeout(() => {
  //       myduplicate.duplicate(['contractName'], control.value).pipe(
  //         distinctUntilChanged((x, y) => _.isEqual(x, y)  ),
  //       ).subscribe((res: boolean) => {
  //         if (res === true) {
  //          // control.setErrors({ duplicate: res });
  //          // resolve({ duplicate: res });
  //         } else {
  //          // resolve(null);
  //         }
  //       }, () => {
  //        // resolve(null);
  //       });
  //       }, 700);
  //     });
  //   };
  // }

  getForm(): FormGroup {
    return this.fb.group({
      contractFilter: this.getFilterContract(),
      newRules: this.getNewRules(),
      contract: this.getContract(),
      rule: this.getRules(),
    })
  }
  getMiscellaneous(): FormGroup {
    return this.fb.group({
      information: this.fb.group({
        created: [null],
        createdBy: [null],
        updated: [null],
        updatedBy: [null],
      }),
      commentsForm: this.fb.group({
        commentsBlog: [null],
        comments: [null],
      }),
    });
  }


  getFilterContract(): FormGroup {
    return this.fb.group({
      name: [null],
      po: [null],
      startDate: [null],
      endDate: [null],
      price: [null, Validators.pattern(NUMERIC_POSITIVE_PATTERN_WITH_DOT)],
      productID: this.fb.group({ id: [null], name: [null] }),
      service: this.fb.group({ id: [null], name: [null] })
    });
  }
  getNewRules(): FormGroup {
    return this.fb.group({
      start: [null, Validators.required],
      end: [null],
    });

  }
  getShiftDate(): FormGroup {
    return this.fb.group({
      BillingShift: [null, Validators.required],
    });

  }

  getContract(): FormGroup {
    return this.fb.group({
      invoicing: this.fb.group({ start: [null, Validators.required], end: [null] }),
      // isIndex: this.fb.group({isIndex: [null]}),
      // isPORequired: this.fb.group({isPORequired: [null]}),
      setting: this.fb.group({isPORequired: [null] , isIndex: [null], isPeriodicAdjustment: [null]}),
      customInvoice: this.fb.group({customInvoice:  [null]}),
      triggerStart: this.fb.group({ triggerStart: this.fb.group({ id:  [null, Validators.required] , name: [null]}) }),
      delay: this.fb.group({ retractationDelay: [null, Validators.pattern(NUMERIC_POSITIVE_PATTERN)],
                             paymentDelay: [null, Validators.pattern(NUMERIC_POSITIVE_PATTERN)] }),
      productID: this.fb.group({ productID: this.fb.group({id: [null, Validators.required], name: [null]}) }),
      recurrence: this.fb.group({
        recurrence: this.fb.group({
          id: [null, Validators.required]
           }),
        billingShiftMonth:  [null],
        billingShiftDay:  [null],
        allowShiftMonth: [null]
      }),
      split: this.fb.group({split: this.fb.group({id: [null , Validators.required], name: [null]}) }),
      sla: this.fb.group({sla:  this.fb.group({ id: [null, Validators.required], name: [null]}) }),
      currency: this.fb.group({currency:  this.fb.group({ id: [null], name: [null] })}),
      displayName: this.fb.group({displayName: [null]}),
      info: this.fb.group({
        created: [null],
        createdBy: [null],
        updated: [null],
        updatedBy: [null]
      }),
      uuid: [null],
      prefix: [],
    });
  }
  getRules(): FormGroup {
    return this.fb.group({
      billing: this.fb.group({
        po: [],
        billingProduct: this.fb.group({ id: [null], name: [null]}),
      }),
      fee: this.fb.group({
        setupFee: [null, Validators.pattern(NUMERIC_POSITIVE_PATTERN_WITH_DOT)],
        musicService: [null, Validators.pattern(NUMERIC_POSITIVE_PATTERN_WITH_DOT)],
        projectManagement: [null, Validators.pattern(NUMERIC_POSITIVE_PATTERN_WITH_DOT)],
        softwareService: [null, Validators.pattern(NUMERIC_POSITIVE_PATTERN_WITH_DOT)],
        materialLocation: [null, Validators.pattern(NUMERIC_POSITIVE_PATTERN_WITH_DOT)],
        communicationFee: [null, Validators.pattern(NUMERIC_POSITIVE_PATTERN_WITH_DOT)],
        maintenanceFee: [null, Validators.pattern(NUMERIC_POSITIVE_PATTERN_WITH_DOT)],
        adminFee: [null, Validators.pattern(NUMERIC_POSITIVE_PATTERN_WITH_DOT)],
        adminFeePercent: [null, Validators.pattern(NUMERIC_POSITIVE_PATTERN_WITH_DOT_0_TO_100)],
      }),
      price: this.fb.group({
        priceFixed: [null, Validators.pattern(NUMERIC_POSITIVE_PATTERN_WITH_DOT)],
      }),
      priceConnection: this.fb.group({
        priceConnectionOn: [null, Validators.pattern(NUMERIC_POSITIVE_PATTERN_WITH_DOT)],
        priceConnectionOff: [null, Validators.pattern(NUMERIC_POSITIVE_PATTERN_WITH_DOT)],
      }),
      id:  [],
      contractID:  [],
      start:  [],
      end: [],
      license: this.fb.group({
        license:  this.fb.group({ id: [null], name: [null] }),
        licenseValue:  [null, Validators.pattern(NUMERIC_POSITIVE_PATTERN_WITH_DOT)],
      }),
      rewards: this.fb.group({
          rewardList: this.fb.array([
           // this.rewardArray(),
          ])
        }),
      evolutionTime: this.fb.group({
        evolutionTimeList: this.fb.array([
        //  this.PriceTimeArray(),
        ])
      }),
      options: this.fb.group({
        optionList: this.fb.array([
          this.OptionArray(),
          this.OptionArray(),
          this.OptionArray(),
          this.OptionArray(),
          this.OptionArray(),
          this.OptionArray(),
          this.OptionArray(),
          this.OptionArray(),
          this.OptionArray(),
          this.OptionArray(),
          this.OptionArray(),
          this.OptionArray(),
          this.OptionArray(),
          this.OptionArray(),
        ])
      }),
      evolutionVolume: this.fb.group({
        PriceVolumeList: this.fb.array([
         // this.PriceVolumeArray(),
        ])
      }),
      misc: this.fb.group({
      created: [],
      createdBy: [],
      updated: [],
      updatedBy: [],
      deleted: [],

    }),
    });
  }
  rewardArray(): FormGroup {
    return this.fb.group({
      id: this.fb.control(''),
      name: this.fb.control('', Validators.required),
      value: this.fb.control('', Validators.required),
    });
  }
  OptionArray(): FormGroup {
    return this.fb.group({
      id: this.fb.control(''),
      key: this.fb.control(''),
      value: this.fb.control('',   Validators.pattern(NUMERIC_POSITIVE_PATTERN_WITH_DOT) ),
      variance: this.fb.control(''),
    });
  }
  PriceTimeArray(): FormGroup {
    return this.fb.group({
      id: this.fb.control(''),
      start: this.fb.control('', Validators.required),
      end: this.fb.control('', Validators.required),
      price: this.fb.control('', Validators.required),
    });
  }

  PriceVolumeArray(): FormGroup {
    return this.fb.group({
      id: this.fb.control(''),
      min: this.fb.control('', Validators.required),
      max: this.fb.control('', Validators.required),
      price: this.fb.control('', Validators.required),
    });
  }
  getFilterSubscription(): FormGroup {
    return this.fb.group({
      subscriptionName: [],
      status: this.fb.group({ id: [null], name: [null] }),
      clientName: [],
      startBilling: [],
      startBillingRangeStart: [],
      startBillingRangeEnd: [],
      price: [null],
      endBilling: [],
      endBillingRangeStart: [],
      endBillingRangeEnd: [],
      deliveryDate: [],
      deliveryDateRangeStart: [],
      deliveryDateRangeEnd: [],
      companyName: [],
      service: this.fb.group({ id: [null], name: [null] }),
      productID: this.fb.group({ id: [null], name: [null] }),
    });
  }

}


